import _ from 'lodash';
import constants from '../../../helpers/constants';

export default resourcesList => resourcesList.map(resource => {
  _.set(resource, 'selected', false);
  _.set(resource, 'value', 0);

  if (resource.type === constants.RESOURCE_TIME_TYPE) {
    _.set(resource, 'valuePerDay', 0);
  }

  return resource;
});
